import type {
  FormSubmissionPayload,
  FormSubmissionResponse,
} from '@/lib/form-handlers';
import { FetchService } from '@/lib/http/FetchService';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export type BoaFormRequest = FormSubmissionPayload;
export type BoaFormResponse = FormSubmissionResponse;

const BOA_SUBMIT_KEY = ['boa', 'submit-form'] as const;
const fetchService = new FetchService('/api');

const submitBoaForm = async (
  body: BoaFormRequest
): Promise<BoaFormResponse> => {
  const response = await fetchService.fetch<BoaFormResponse>(
    'submit-formsort-form',
    { method: 'POST', body: JSON.stringify(body) }
  );
  if (!response.success) {
    throw new Error(response.error ?? 'Form submission failed');
  }
  return response;
};

export const useSubmitBoaFormMutation = (
  options?: Omit<
    UseMutationOptions<BoaFormResponse, Error, BoaFormRequest>,
    'mutationFn'
  >
) =>
  useMutation<BoaFormResponse, Error, BoaFormRequest>({
    mutationKey: BOA_SUBMIT_KEY,
    mutationFn: submitBoaForm,
    ...options,
  });
